import React, { FC } from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { StyledBreadcrumbs } from './styled';
import { BreadcrumbsProps } from './types';

const PageBreadcrumbs: FC<BreadcrumbsProps> = ({ breadcrumbs }) => {
  return (
    <StyledBreadcrumbs separator={<NavigateNextIcon fontSize='small' />} aria-label='breadcrumb'>
      {breadcrumbs}
    </StyledBreadcrumbs>
  );
};

export default PageBreadcrumbs;
